import { createStore } from "effector";

import {
  resetDateRangeFilter,
  updateDateRangeFilter,
} from "./DateRangeFilterEvents";
import {
  DateRangeFilterState,
  FormattedDateRangeFilterState,
} from "./DateRangeFilterState";

import { Formatter } from "@/lib/formatter";

const API_DATE_FORMAT = "dd/MM/yyyy";

const initialState: DateRangeFilterState = {
  startDate: new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    new Date().getDate(),
    0,
    0,
    0
  ),
  endDate: new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    new Date().getDate(),
    23,
    59,
    59
  ),
  isFiltering: true,
};

export const DateRangeFilterStore = createStore<DateRangeFilterState>(
  initialState
)
  .on(
    updateDateRangeFilter,
    (_, { startDate, endDate, isFiltering = true }) => {
      return {
        startDate,
        endDate,
        isFiltering,
      };
    }
  )
  .on(resetDateRangeFilter, () => initialState);

export const formattedDateRangeFilterSelector = (
  state: DateRangeFilterState
): FormattedDateRangeFilterState => {
  return {
    startDate: Formatter.date(state.startDate, {
      formatStr: API_DATE_FORMAT,
    }),
    endDate: Formatter.date(state.endDate, {
      formatStr: API_DATE_FORMAT,
    }),
    isFiltering: state.isFiltering,
  };
};
